export default __webpack_public_path__ + "static/media/blue-tick.f5d82153.svg";